import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

/**
 * Medical Debt Chart
 * Shows total medical debt stock - baseline vs SAFECARE redemption
 */
export default function MedicalDebtChart({ data }) {
    const chartData = data.map(year => ({
        year: year.year,
        'Baseline Medical Debt': (year.medicalDebtBaseline / 1e9).toFixed(1),
        'SAFECARE (with Redemption)': (year.medicalDebtSafecare / 1e9).toFixed(1)
    }));

    return (
        <div className="chart-container">
            <h3>Medical Debt Stock</h3>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="var(--bg-tertiary)" />
                    <XAxis
                        dataKey="year"
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                    />
                    <YAxis
                        stroke="var(--text-secondary)"
                        style={{ fontSize: '11px', fontWeight: 600 }}
                        label={{ value: 'Billions $', angle: -90, position: 'insideLeft', fill: 'var(--text-muted)', fontSize: '11px' }}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: 'rgba(255, 255, 255, 0.96)',
                            border: '1px solid var(--glass-border)',
                            borderRadius: '12px',
                            color: 'var(--text-primary)',
                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                            fontSize: '13px'
                        }}
                        formatter={(value) => `$${value}B`}
                    />
                    <Legend
                        wrapperStyle={{ color: 'var(--text-primary)', fontSize: '12px', fontWeight: 600, paddingTop: '10px' }}
                    />
                    <Line
                        type="monotone"
                        dataKey="Baseline Medical Debt"
                        stroke="#ff6b6b"
                        strokeWidth={2}
                        dot={{ fill: '#ff6b6b', r: 3 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="SAFECARE (with Redemption)"
                        stroke="#51cf66"
                        strokeWidth={2}
                        dot={{ fill: '#51cf66', r: 3 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
